import { useCallback } from "react"
import * as EventTypeEnum from "../event-type-enum";
import useEventBusListener from "./use-event-bus-listener";

function useOnEntityDeleted(entityType = null, entityId = null, onDeleted = ({ entityType, entityId, isDeleted = true }) => { }) {

    const entityTypeFilter = entityType;
    const entityIdFilter = entityId;
    const eventReceived = useCallback(({ entityId, entityType, isDeleted = true }) => {
        if ((entityTypeFilter === null || entityTypeFilter === undefined || entityType === entityTypeFilter) &&
            (entityIdFilter === null || entityIdFilter === undefined || entityId === entityIdFilter))
            onDeleted({ entityId, entityType, isDeleted });
    }, [onDeleted, entityTypeFilter, entityIdFilter]);

    useEventBusListener(EventTypeEnum.EntityDeleted, eventReceived, true);

}
export default useOnEntityDeleted;